import { Routes, Route } from "react-router-dom";

import { RouteConstants } from "constant";

import CardListPage from "pages/cards/list";
import CardViewPage from "pages/cards/view";
import ChatPage from "pages/chat";
import ClientListPage from "pages/clients/list";
import CLientNewPage from "pages/clients/new";
import ClientViewPage from "pages/clients/view";
import MyCLientsPage from "pages/clients-my/list";
import ReplacementClientsPage from "pages/replacement-clients";
import ControlPage from 'pages/control';
import DashboardPage from "pages/dashboard";
import Error404Page from "pages/error/404";
import Error406Page from "pages/error/406";
import Error500Page from "pages/error/500";
import Error503Page from "pages/error/503";
import HolidaysPage from "pages/holidays";
import MotivationalMessagesPage from "pages/motivational-messages";
import PermissionsPage from 'pages/permissions';
import AgentPermissionsPage from 'pages/permissions/agents/AgentPermissionsPage';
import TemplateFormPage from 'pages/permissions/templates/TemplateFormPage';
import ProfilePage from "pages/profile";
import LoginPage from "pages/public/login";
import RegistrationSetPassword from "pages/public/registration/set-password";
import RegistrationVerifyCode from "pages/public/registration/verify-code";
import WelcomePage from "pages/public/welcome";
import UserRecommendationListPage from "pages/recommendations/list";
import TargetsPage from "pages/targets";
import TodoListPage from 'pages/todo/list';
import UsersListPage from "pages/users/list";


const CustomRouter = () => {
  return (
    <Routes>
      <Route path={"/"} element={<WelcomePage />} />
      <Route path={RouteConstants.ROUTE_LOGIN} element={<LoginPage />} />
      <Route path={RouteConstants.ROUTE_DASHBOARD} element={<DashboardPage />} />

      <Route path={RouteConstants.ROUTE_REGISTRATION + "/mail-bestätigen"} element={<RegistrationVerifyCode />} />
      <Route path={RouteConstants.ROUTE_REGISTRATION + "/passwort-festlegen"} element={<RegistrationSetPassword />} />

      <Route path={RouteConstants.ROUTE_CHAT} element={<ChatPage />} />

      <Route path={RouteConstants.ROUTE_CARDS} element={<CardListPage />} />
      <Route path={RouteConstants.ROUTE_CARDS + "/:id"} element={<CardViewPage />} />
      <Route path={RouteConstants.ROUTE_CARDS} element={<CardListPage />} />

      <Route path={RouteConstants.ROUTE_CLIENTS} element={<ClientListPage />} />
      <Route path={RouteConstants.ROUTE_CLIENTS + "/:id"} element={<ClientViewPage />} />
      <Route path={RouteConstants.ROUTE_MY_CLIENTS} element={<MyCLientsPage />} />
      <Route path={RouteConstants.ROUTE_MY_CLIENTS + "/:id"} element={<ClientViewPage />} />
      <Route path={RouteConstants.ROUTE_REPLACEMENT_CLIENTS} element={<ReplacementClientsPage />} />
      <Route path={RouteConstants.ROUTE_CLIENTS_NEW} element={<CLientNewPage />} />

      <Route path={RouteConstants.ROUTE_USERS} element={<UsersListPage />} />
      <Route path={RouteConstants.ROUTE_USER_RECOMMENDATIONS} element={<UserRecommendationListPage />} />
      <Route path={RouteConstants.ROUTE_PROFILE} element={<ProfilePage />} />
      <Route path={RouteConstants.ROUTE_PROFILE + "/:id"} element={<ProfilePage />} />

      <Route path={RouteConstants.ROUTE_CONTROL} element={<ControlPage />} />
      <Route path={RouteConstants.ROUTE_TODO} element={<TodoListPage />} />
      <Route path={RouteConstants.ROUTE_PERMISSIONS} element={<PermissionsPage />} />
      <Route path={RouteConstants.ROUTE_HOLIDAYS} element={<HolidaysPage />} />
      <Route path={RouteConstants.ROUTE_MOTIVATIONAL_MESSAGES} element={<MotivationalMessagesPage />} />
      <Route path={RouteConstants.ROUTE_TARGETS} element={<TargetsPage />} />
      <Route path={RouteConstants.ROUTE_PERMISSIONS + "/sabloni/:id"} element={<TemplateFormPage />} />
      <Route path={RouteConstants.ROUTE_PERMISSIONS + "/agenti/:id"} element={<AgentPermissionsPage />} />

      <Route path={RouteConstants.ROUTE_ERROR_406} element={<Error406Page />} />
      <Route path={RouteConstants.ROUTE_ERROR_500} element={<Error500Page />} />
      <Route path={RouteConstants.ROUTE_ERROR_503} element={<Error503Page />} />

      <Route path="*" element={<Error404Page />} />
    </Routes>
  )
}

export default CustomRouter;
